export default __webpack_public_path__ + "static/media/28.404d336a.png";